const innerW = window.innerWidth;

if (innerW<=768) {
  window.addEventListener('scroll', function() {
    const addtocart = document.querySelector('.add-to-card-preorde-btn');
    const zdaddtocart = this.document.querySelector('.add-to-card-preorder2');
    let rect = addtocart.getBoundingClientRect();
    let distanceFromTop = rect.top;
    if (distanceFromTop<0) {
      zdaddtocart.style.display = "block";
    } else {
      zdaddtocart.style.display = "none";
    }
    // const addtocart2 = document.querySelector('.add-to-card-preorder2')
    // const top = addtocart.getBoundingClientRect().top;
    // if (top<0) {
    //   addtocart2.style.display = 'block'
    // } else {
    //   addtocart2.style.display = 'none'
    // }
  })
}
if (innerW >= 768) {
  let dom = document.querySelector('.product__info-container');
  // let stickyDom = document.querySelector('.product__title_div');
  // let HeightDomHeight = document.querySelector('.rio-media-gallery').getBoundingClientRect().height;
  // dom.style.minHeight = (HeightDomHeight + HeightDomHeight* 0.2) + 'px';
  // window.addEventListener('scroll', function() {
  //   let Gallery = document.querySelector('.rio-media-gallery').getBoundingClientRect();
  //   const bottom = Gallery.top + Gallery.height;
  //   if (bottom <= windowHeight) {
  //     // stickyDom.style.position = "static";
  //   } else {
      
  //   }
  // })
  // console.log('HeightDom.getBoundingClientRect().height', HeightDomHeight + HeightDomHeight * 0.67)
  // console.log('dom', dom, (HeightDomHeight + HeightDomHeight.height * 0.5) + 'px')

  // debugger
  // let paddingRightDom = document.querySelector('.page-width');
  // let paddingRight = window.getComputedStyle(paddingRightDom).getPropertyValue('padding-right');
  // let ProductContainer = document.querySelector('.product__info-container');
  // let product = document.querySelector('.product');
  // let MainContent = document.querySelector('.MainProduct');
  // window.addEventListener('scroll', function() {
  //   let top = product.getBoundingClientRect().top;
  //   let bottom = MainContent.getBoundingClientRect().bottom;
  //   console.log('top', top, 'bottom', bottom)
  //   if (top <=0) {
  //     ProductContainer.classList.add('fixed');
  //     ProductContainer.style.paddingRight = paddingRight;
  //   } else if(bottom >= 0){
  //     ProductContainer.classList.remove('fixed');
  //   }
  // })
}